import { memo as G, useMemo as L, useRef as H, useEffect as I } from "react";
import { Box3 as $, Vector3 as M, Raycaster as q, MeshLambertMaterial as C, DoubleSide as P, Vector2 as T, MathUtils as J } from "three";
import { getRgMesh as K } from "../../../3d/rg-render-types/index3.js";
import { RgView as N, isRgView as Q } from "../../../3d/rg-render-types/index4.js";
import { V3toVector3 as R } from "../../../geometry-utils/index9.js";
import { Direction as X } from "../../../utils/index7.js";
import { Vectors as o } from "../../../utils/index36.js";
import { SvgRgView as E } from "../svg-rg-view/index.js";
import { jsx as s, jsxs as Y } from "react/jsx-runtime";
const d = new $(), u = new M(), B = new M(), F = new q(), Z = new M(), v = 0.25, _ = 0.115, ee = new C({
  side: P
});
let z = !1, t = new T();
const te = [
  [0.5, 0.5],
  [0.01, 0.01],
  [0.5, 0.99],
  [0.99, 0.5],
  [0.99, 0.75],
  [0.99, 0.25],
  [0.99, 0.99],
  [0.5, 0.25],
  [0.5, 0.75],
  [0.5, 0.01],
  [0.25, 0.25],
  [0.25, 0.75],
  [0.75, 0.75],
  [0.75, 0.25],
  [0.01, 0.25],
  [0.01, 0.5],
  [0.01, 0.75],
  [0.01, 0.99],
  [0.99, 0.01]
], re = ({
  rayStartV3: O,
  list: m,
  intersectedSet: r,
  intersectedDist: k,
  lookingForView: x
}) => {
  F.set(Z.fromArray(O), o.Forward);
  const i = F.intersectObjects(m, !1);
  if (i.length) {
    let g = i[0].object;
    i.length >= 2 && Math.abs(i[0].distance - i[1].distance) <= _ && i[1].object.parent === x && (g = i[1].object);
    const a = g.parent;
    return r.has(a) || a !== x ? void 0 : (r.add(a), k.set(a, i[0].distance), a);
  }
}, fe = G(function({
  obj: m,
  camForward: r,
  filter: k,
  style: x,
  sectionViewOffset: i = 0,
  svgCallback: g
}) {
  const a = Object.keys(x), c = L(() => {
    const e = new N(m, ee);
    e.up.set(0, 1, 0), e.lookAt(e.position.clone().sub(R(r))), e.updateWorldMatrix(!0, !0), e.rotateOnAxis(new M(1, 0, 0), Math.PI);
    const n = (m.children[0].rot[1] + 360) % 360;
    let f = 0;
    n >= 0 && n <= 90 ? f = 90 : n > 90 && n <= 180 ? f = 180 : n > 180 && n <= 270 ? f = 270 : n > 270 && n <= 360 && (f = 360);
    const S = n % f;
    return e.rotateOnAxis(new M(0, 1, 0), J.DEG2RAD * -S), r === o[X.Up] ? z = !0 : z = !1, e;
  }, [r, m]), U = L(() => {
    d.setFromObject(c), d.getSize(u), d.getSize(B);
    const e = d.min, n = d.max;
    if (t = new T(e.x, n.y), z)
      return [];
    const f = /* @__PURE__ */ new Set(), S = /* @__PURE__ */ new Map(), A = [], W = a.flat();
    c.traverse((h) => {
      if (!Q(h))
        return;
      const p = h;
      !W.includes(p.userData.type) || A.push(K(p));
    }), r = R(r);
    const l = r.x * u.z + r.y * u.z + r.z * u.z;
    let y;
    switch (r) {
      case o.Forward:
        y = o.Forward.clone().multiplyScalar((l < 0 ? -l : 0) - v + i).add(c.position), B.negate();
        break;
      case o.Back:
        y = o.Forward.clone().multiplyScalar((l < 0 ? l : 0) - v + i).add(c.position);
        break;
      case o.Right:
        B.negate(), y = o.Forward.clone().multiplyScalar((l > 0 ? -l : 0) - v + i).add(c.position);
        break;
      case o.Left:
        y = o.Forward.clone().multiplyScalar((l > 0 ? -l : 0) - v + i).add(c.position);
        break;
      case o.Up:
        y = o.Forward.clone().multiplyScalar((l > 0 ? -l : 0) - v + 0.4).add(c.position);
        break;
      default:
        y = o.Forward.clone().multiplyScalar(-1e3).add(c.position);
    }
    for (const h of A) {
      const p = h.parent;
      h.material.side = P, d.setFromObject(h), d.getSize(u);
      for (const b of te)
        if (re({
          rayStartV3: [d.min.x + u.x * b[0], d.min.y + u.y * b[1], y.z],
          list: A,
          intersectedSet: f,
          intersectedDist: S,
          lookingForView: p
        }))
          break;
    }
    const V = Array.from(f);
    return V.sort((h, p) => {
      const b = S.get(h), j = S.get(p);
      return Math.abs(j - b) > 0.01 ? j - b : a.indexOf(h.userData.type) - a.indexOf(p.userData.type);
    }), V;
  }, [m, c, r, i]), w = H(null);
  I(() => {
    if (!w.current)
      return;
    const e = w.current.getBBox();
    w.current.setAttribute("viewBox", [e.x, e.y, e.width, e.height].join(" ")), g && g(w.current.outerHTML);
  });
  const D = {
    fill: "black",
    fillOpacity: 1,
    stroke: "black",
    strokeWidth: 0.01
  };
  return /* @__PURE__ */ s("svg", {
    ref: w,
    style: {
      display: "block",
      pointerEvents: "none"
    },
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ Y("g", {
      children: [z && a.map((e, n) => /* @__PURE__ */ s("g", {
        name: `show-${e}`,
        children: /* @__PURE__ */ s(E, {
          view: c,
          show: [e],
          camForward: R(r),
          filter: k,
          style: x,
          recursive: !0
        })
      }, n)), !z && Array.from(U).map((e, n) => /* @__PURE__ */ s(E, {
        view: e,
        show: a,
        camForward: R(r),
        filter: k,
        style: x,
        recursive: !1
      }, n)), /* @__PURE__ */ s("text", {
        x: t.x,
        y: t.y + 1.9,
        fontSize: "2%",
        children: "0"
      }), /* @__PURE__ */ s("rect", {
        x: t.x,
        y: t.y + 2,
        name: "graphic-scale-1",
        width: "1",
        height: "0.25",
        style: D
      }), /* @__PURE__ */ s("text", {
        x: t.x + 1,
        y: t.y + 1.9,
        fontSize: "2%",
        children: "1"
      }), /* @__PURE__ */ s("rect", {
        x: t.x + 1,
        y: t.y + 2.25,
        name: "graphic-scale-2",
        width: "1",
        height: "0.25",
        style: D
      }), /* @__PURE__ */ s("text", {
        x: t.x + 2,
        y: t.y + 1.9,
        fontSize: "2%",
        children: "2"
      }), /* @__PURE__ */ s("rect", {
        x: t.x + 2,
        y: t.y + 2,
        name: "graphic-scale-3",
        width: "1",
        height: "0.25",
        style: D
      }), /* @__PURE__ */ s("text", {
        x: t.x + 3,
        y: t.y + 1.9,
        fontSize: "2%",
        children: "3"
      }), /* @__PURE__ */ s("rect", {
        x: t.x + 3,
        y: t.y + 2.25,
        name: "graphic-scale-4",
        width: "1",
        height: "0.25",
        style: D
      }), /* @__PURE__ */ s("text", {
        x: t.x + 4,
        y: t.y + 1.9,
        fontSize: "2%",
        children: "4 M"
      })]
    })
  });
});
export {
  fe as SvgRenderer
};
//# sourceMappingURL=index.js.map
